<template>
  <b-container v-if="verified">
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            OCR Handwriting
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input">Input Image:</label>
            <input ref="fileupload" class="mb-2 sm-input" type="file" accept="image/png, image/jpeg" @change="onChooseImage">
          </div>
          <div class="form-button col-12" style="display: flex">
            <div class="sm-nav-wrapper" style="margin-left: auto">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-12">
            <label v-if="showPreview" class="textarea-input">Preview Image:</label>
            <canvas v-show="showPreview && currCanvas == 'preview'" id="cvs-preview" class="preview-canvas mb2"></canvas>
            <canvas v-show="showPreview && currCanvas == 'original'" id="cvs-original" @click="currCanvas = 'ocr'" style="cursor:pointer;" class="preview-canvas mb2"></canvas>
            <canvas v-show="showPreview && currCanvas == 'ocr'" id="cvs-ocr" @click="currCanvas = 'original'" style="cursor:pointer;" class="preview-canvas mb2"></canvas>
            <!-- <b-img v-if="showPreview" :src="imagePreview" class="preview-canvas mb-2"></b-img> -->
          </div>
        </CRow>
      </div>
      <!-- <CRow v-if="keywords.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            RESPONSE DATA
          </h4>
        </CCol>
      </CRow>
      <b-img v-if="fileResult.length > 0" :src=fileResult class="preview-image-response mb-4"></b-img>
      <div v-if="keywords.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="keywords"
            >
              <template #cell(confidence)="row">
                <b-badge v-if="row.value.badge == 'Good'" variant="success">{{row.value.badge}} - {{row.value.percentage}} %</b-badge>
                <b-badge v-else variant="danger">{{row.value.badge}} - {{row.value.percentage}} %</b-badge>
              </template>
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div> -->
      <TheFooter></TheFooter>
    </b-card>
    <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
      <div slot="body">
        <label>{{errorLabel}}</label>
        <div class="btn-footer">
          <button class="btn-submit white" @click="showErrorModal = false">
            Tutup
          </button>
        </div>
      </div>
    </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
// import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      verified: false,
      isLoading: false,
      showErrorModal: false,
      // showOfficeModal: false,
      // showDaytimeModal: false,
      // showClocktimeModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      showPreview: false,
      currCanvas: 'preview',
      file: null,
      boxes: [],
      // inputText: "",
      // fields: [
        //     { key: 'label', label: 'Label' },
      //     { key: 'value', label: 'Value' },
      //     { key: 'confidence', label: 'Confidence' },
      // ],
      // keywords: [],
      // fileResult: "",
      // imagePreview: null,
      // categoryMap: [],
      // base64: "",
      // serviceId: "",
      // serviceName: "",
      // customerId: "",
      // contractNo: "",
      // servOfficeCode: "",
      // workDayBook: 1,
      // officeOptions: [],
      // daytimeOptions: [],
      // clocktimeOptions: [],
      // selectedOffice: {},
      // selectedDaytime: {},
      // selectedClocktime: {}
    }
  },
  methods: {
    onChooseImage(e){
      this.keywords = []
      this.fileResult = []
      const file = e.target.files[0]
      if(file){
        this.file = e.target.files[0]
        // this.imagePreview = URL.createObjectURL(file)
        const cvs = document.getElementById('cvs-preview')
        const ctx = cvs.getContext('2d')
        const cvs2 = document.getElementById('cvs-original')
        const ctx2 = cvs2.getContext('2d')
        const cvs3 = document.getElementById('cvs-ocr')
        const ctx3 = cvs3.getContext('2d')
        ctx.clearRect(0, 0, cvs.width, cvs.height)
        ctx2.clearRect(0, 0, cvs.width, cvs.height)
        ctx3.clearRect(0, 0, cvs.width, cvs.height)
        const img = new Image
        img.src = URL.createObjectURL(e.target.files[0])
        img.onload = function() {
          cvs.width = img.width
          cvs.height = img.height
          ctx.drawImage(img, 0, 0)
          cvs2.width = img.width
          cvs2.height = img.height
          ctx2.drawImage(img, 0, 0)
          cvs3.width = img.width
          cvs3.height = img.height
          ctx3.drawImage(img, 0, 0)
        }
        // this.createBase64Image(file)
        this.currCanvas = 'preview'
        this.showPreview = true
      }
    },
    // createBase64Image(FileObject) {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     this.base64 = reader.result.split(",")[1];
    //   }
    //   reader.readAsDataURL(FileObject);
    // },
    drawOriginalBox() {
      const cvs = document.getElementById("cvs-original")
      const ctx = cvs.getContext("2d")
      ctx.strokeStyle = "red"
      ctx.lineWidth = parseInt(cvs.width/1000) + 1
      ctx.beginPath()
      for(let box of this.boxes){
        ctx.rect(box.xmin, box.ymin, box.xmax-box.xmin, box.ymax-box.ymin)
      }
      ctx.stroke()
    },
    drawOCRBox() {
      const cvs = document.getElementById("cvs-ocr")
      const ctx = cvs.getContext("2d")
      ctx.textAlign="left"; 
      ctx.textBaseline = "middle";
      ctx.beginPath()
      for(let box of this.boxes){
        ctx.fillStyle = "white"
        ctx.fillRect(box.xmin, box.ymin, box.xmax-box.xmin, box.ymax-box.ymin)
        var rectHeight = box.ymax - box.ymin;
        // var rectWidth = box.xmax - box.xmin;
        var text_size = parseInt(cvs.width/60) + 1;
        var text_font = "Georgia";
        ctx.font = text_size + "px " + text_font;
        var textMetrics = ctx.measureText(box.text);
        var actualHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
        // var actualWidth = textMetrics.actualBoundingBoxLeft + textMetrics.actualBoundingBoxRight;
        var text_ratio = 1.8;
        while (actualHeight * text_ratio > rectHeight) {
        // while (actualWidth * text_ratio > rectWidth || actualHeight * text_ratio > rectHeight) {
          // if(actualWidth * text_ratio > rectWidth){
          //   rectWidth++;
          // }
          text_size = text_size - 1;
          ctx.font = text_size + "px " + text_font;
          textMetrics = ctx.measureText(box.text);
          actualHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
          // actualWidth = textMetrics.actualBoundingBoxLeft + textMetrics.actualBoundingBoxRight;
        }
        ctx.fillStyle = "black"
        ctx.fillText(box.text, box.xmin+10, (box.ymin+box.ymax)/2);
      }
      ctx.stroke()
    },
    onClickSubmit(){
      this.isLoading = true
      let processUrl = "https://validation.demo.inergi.id/api/api-handwriting/handwriting/v1/boxPredict"
      // let processUrl = "https://ktp.ocr.dev.inergi.id/api-handwriting/handwriting/v1/boxPredict"
      let data = new FormData()
      data.set('image', this.file)
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          this.boxes = response.data.data
          this.drawOriginalBox()
          this.drawOCRBox()
          this.currCanvas = 'original'
          // if(raw.success) {
          //   let entries = []
          //   for (const [key, value] of Object.entries(raw.data)){
          //     let result = "Good"
          //     if(value.confidence < 0.9){
          //       result = "Bad"
          //     }
          //     entries.push({label: key, value: value.value, confidence: {"badge": result, "percentage": (value.confidence * 100).toFixed(2)}})
          //   }
          //   this.keywords = entries
          //   this.fileResult = "https://ktp.ocr.dev.inergi.id/api-stnk"+raw.url
          // } else {
          //   this.errorLabel = raw.message
          //   this.errorReload = false
          //   this.showErrorModal = true
          // }
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
          return
        }
      })
      .catch(error => {
        // if(error.response) this.errorLabel = error.response.data.reason
        if(error.response){
          if(error.response.status == "401"){
            this.errorLabel = "API Key tidak valid atau sudah tidak berlaku. Mohon menghubungi tim untuk kode akses baru."
            this.$cookies.remove("api-key-handwriting")
            delete this.$axios.defaults.headers.post['API-Key']
          }
          else{
            if(error.response.data && error.response.data.reason) this.errorLabel = error.response.data.reason
            else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          }
        }
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  async mounted() {
    // this.$axios.defaults.headers.post['Content-Type'] = 'application/json';
    // this.$axios.post(processUrl, data, { headers: {"Content-Type": "multipart/form-data"} }).then((response) => {
    let res = ""
    if(this.$cookies.get("api-key-handwriting")){
      res = this.$cookies.get("api-key-handwriting")
      this.$axios.defaults.headers.post['API-Key'] = res
      this.$axios.defaults.headers.get['API-Key'] = res
      this.verified = true
    }
    else{
      while(!res) res = window.prompt("Please enter your access key.", "")
      while(!this.verified){
        // await this.$axios.post("http://10.10.131.108:9000/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
        await this.$axios.post("https://validation.demo.inergi.id/api/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
          this.$cookies.set("api-key-handwriting", res)
          this.$axios.defaults.headers.post['API-Key'] = res
          this.$axios.defaults.headers.get['API-Key'] = res
          this.verified = true
        })
        .catch(error => {
          if(error.response){
            if(error.response.status == "401"){
              res = ""
              while(!res) res = window.prompt("Key validation failed. Please enter your access key.", "")
            }
            else{
              res = ""
              while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
            }
          }
          else{
            res = ""
            while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
          }
        })
      }
    }
  },
}
</script>